
    import HeadingSection from '../../components/MainComponent/HeadingSection.vue';
    import ServicesInformation from '../../components/Service/ServicesInformation.vue';
    import DesignTechnologies from '../../components/Service/DesignTechnologies.vue';
    import OtherServices from '../../components/MainComponent/OtherServices.vue';

    export default {
        components: {
            HeadingSection,
            ServicesInformation,
            DesignTechnologies,
            OtherServices,
        },
        computed: {
            singleServicePageData() {
                return this.$store.state.singleServicePageData;
            },
        },
        async asyncData(context) {
            const path = context.route.params.slug;
            await context.app.$getDataFromCache(`/wp-json/wp/v2/pages?slug=${path}`)
                .then((response) => {
                    if (response.data.length) {
                        context.store.dispatch("setSingleServicePageData", response.data[0]);
                    } else {
                        context.redirect('/');
                    }
                });
            await context.store.dispatch("setPageChangeAnimationValueFalse");
        },
    };
